import React from "react";

const Links = () => {
  return <div>Links</div>;
};

export default Links;



// WEBPACK FOOTER //
// ./src/components/Links.js